import { useContext, useEffect } from 'preact/hooks';
import { createContext } from 'preact'
import { form } from 'api';
import { setErrors } from 'utils/error';
import { useForm } from 'react-hook-form';
import { useWidget } from './widget.context';
import Button from 'components/layout/button';
import { Text } from 'preact-i18n';
import style from 'components/form/single-step/singleStep.form.scss'
import { jsonColorConvertor } from 'utils/colorConvertor';
import {
  hiddenFieldsValues,
  setRefererAddress,
} from 'utils/form-static-value-generator'

const generateFormDefaultValues = (valuesByAliasField, fields) => {
  let defaultValues = {}
  fields.map(field => {
    defaultValues = {
      ...defaultValues,
      [field.slug]: ""
    }
  })
  return { ...defaultValues, ...valuesByAliasField }
}
const SingleStepFormContext = createContext()

const SingleStepFormProvider = ({ children }) => {
  const {
    formData: {
      formFields,
      formSlug,
      buttonBackground,
      submitTextColor,
      submitButtonText,
      initialValues: valuesByAliasField
    },
    closeWidget } = useWidget();
  // Form hook
  const {
    register,
    handleSubmit,
    errors,
    formState,
    setError,
    setValue,
    control,
    watch,
  } = useForm({
    mode: 'onChange',
    defaultValues: { ...generateFormDefaultValues(valuesByAliasField, formFields) }
  })

  useEffect(() => {
    if (errors && Object.keys(errors).length) {
      scrollToFirstError(errors)
    }
  }, [errors])

  const submitForm = async (data) => {
    const formData = { ...data, ...hiddenFieldsValues(), ...setRefererAddress() }
    try {
      const { data: theData, errors: formErrors } = await form().submit(formData, formSlug)
      if (theData.row) {
        closeWidget()
        return
      }
      setErrors(formErrors, setError)
      scrollToFirstError(formErrors.form_errors)
    } catch (error) {
      setErrors(error, setError)
      scrollToFirstError(error.form_errors)

    }
  }

  const scrollToFirstError = (theErrors) => {
    document.getElementById(`singleStep_field_${Object.keys(theErrors)[0]}`).scrollIntoView({ behavior: "smooth" })
  }

  const onError = theErrors => {
    if (theErrors && Object.keys(theErrors).length) {
      scrollToFirstError(theErrors)
    }
  }

  const customizedStyle = {
    backgroundColor: jsonColorConvertor(buttonBackground),
    color: jsonColorConvertor(submitTextColor)
  }
  const SubmitText = submitButtonText || <Text id="form.submit" />

  return (
    <SingleStepFormContext.Provider
      value={{
        register,
        handleSubmit,
        errors,
        formState,
        setError,
        setValue,
        control,
        watch,
      }}
    >
      <form onSubmit={handleSubmit(submitForm, onError)} className={style.singleStep_form} id="formaloo-widget-form">
        <div className={style.singleStep_fieldWrapper}>
          {children}
        </div>
        <Button type="submit" disabled={formState.isSubmitting} className={style.submitButton} style={customizedStyle}>
          {formState.isSubmitting ? <Text id="form.submitting" /> : SubmitText}
        </Button>
      </form>
    </SingleStepFormContext.Provider>
  )
}

const useSingleStepForm = () => {
  const context = useContext(SingleStepFormContext)
  if (context === undefined) {
    throw new Error(
      `useSingleStepForm must be used within a SingleStepFormProvider`,
    )
  }
  return context
}
export { SingleStepFormContext, SingleStepFormProvider, useSingleStepForm }
